export const GUTTER_BETWEEN_TABS = 24;
